import { render } from "./QRCode.vue?vue&type=template&id=9de3f234&scoped=true&ts=true"
import script from "./QRCode.vue?vue&type=script&lang=ts"
export * from "./QRCode.vue?vue&type=script&lang=ts"

import "./QRCode.vue?vue&type=style&index=0&id=9de3f234&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9de3f234"]])

export default __exports__